@if (vm) {
    <div class="timeformtip-header">
        <div class="timeformtip-logo left"></div>
    </div>
    <div class="participants">
        <div class="timeform-participant clearfix">
            <div class="runner-info">
                @if (vm.participantInfo.silkUrl) {
                    <ms-horses-silk [src]="vm.participantInfo.silkUrl" [description]="vm.participantInfo.silkDescription" />
                }
                <div>
                    <div class="timeform-runner-info">
                        <div class="runner-info-numbers">
                            <span class="runner-number">{{ vm.participantInfo.raceCardNumber }}</span>
                        </div>
                        <div class="name-group runner-info-item">
                            <span class="runner-name">{{ vm.participant.name | msTranslate }}</span>
                        </div>
                    </div>
                    @if (vm.participantInfo.ratingStars) {
                        <ms-star-rating [rating]="vm.participantInfo.ratingStars" />
                    }
                </div>
            </div>
            <div class="timeformtip-comment-container">
                @if (vm.hasAnalyst) {
                    <div class="timeformtip-comment" [class.timeformtip-comment-hidden]="!vm.expandedTimeformTip" (click)="toggleTimeformTip()">
                        {{ vm.fixture.timeform?.analystVerdict }}
                    </div>
                }
            </div>
        </div>
        <div class="timeform-pick-details">
            @if (isOptionBet) {
                <div class="odds-wrapper">
                    @if (vm.eventOption && selectedOptionGroup) {
                        <ms-hr-option-pick
                            class="odds-info ms-selectable-pick"
                            [option]="vm.eventOption"
                            [optionGroup]="selectedOptionGroup"
                            [event]="fixture"
                            [participant]="participant"
                            [trackingSource]="trackingSource"
                            [trackingModuleType]="trackingModuleType"
                            [trackingOptions]="trackingOptions"
                            [pickType]="pickType"
                            [checkSiblingSelected]="true">
                            @if (vm.eventOption.online) {
                                <div>
                                    <span class="timeform-odds">
                                        @if (vm.eventOption.participantPriceType !== startingPriceType && nativePrice) {
                                            <span class="option-value">{{ nativePrice | msExternalPriceFormatter }}</span>
                                        }
                                        @if (vm.eventOption.participantPriceType === startingPriceType) {
                                            <span>{{ siteCore.betslip.messages.StartingPrice }}</span>
                                        }
                                    </span>
                                </div>
                            } @else {
                                <div class="lock odds-info">
                                    <vn-icon name="theme-locked-i" size="12" class="lock-icon" />
                                </div>
                            }
                        </ms-hr-option-pick>
                    }
                </div>
            } @else {
                @if (vm.option) {
                    <ms-fixture-pick
                        trackingSource="horseracing_timeform_tip"
                        class="odds-info"
                        [fixture]="vm.fixture"
                        [participant]="vm.participant"
                        [option]="vm.option"
                        [trackingOptions]="trackingOptions">
                        @switch (vm.isOptionActive) {
                            @case (true) {
                                <span class="timeform-odds">
                                    @if (vm.option.priceType !== startingPriceType) {
                                        <span class="option-value">{{ vm.option.price | msExternalPriceFormatter }}</span>
                                    }
                                    @if (vm.option.priceType === startingPriceType) {
                                        <span>{{ siteCore.betslip.messages.StartingPrice }}</span>
                                    }
                                </span>
                            }
                            @case (false) {
                                <div class="odds-info">
                                    <vn-icon name="theme-locked-i" size="12" class="lock-icon" />
                                </div>
                            }
                        }
                    </ms-fixture-pick>
                }
            }
            @if (vm.hasAnalyst) {
                <button ds-button-icon kind="tertiary" variant="flat-reduced" size="medium" class="timeformtip-arrow" (click)="toggleTimeformTip()">
                    <vn-icon [name]="vm.expandedTimeformTip ? 'theme-up' : 'theme-down'" />
                </button>
            }
        </div>
    </div>
}
